import { Component, OnInit } from "@angular/core";
import { Injectable, ViewChild } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormArray,
  UntypedFormBuilder,
} from "@angular/forms";

import { DaoService } from "./../../services/dao.service";
import { Router } from "@angular/router";
import { LstorageService } from "./../../services/lstorage.service";
import * as jwtDecode from "jwt-decode";
import { SpinnerService } from "src/app/shared/spinner/spinner.service";
import { SpinnerComponent } from "src/app/shared/spinner/spinner.component";
import { UserdeleteComponent } from "../userdelete/userdelete.component";
import { ToastService } from "src/app/services/toast.service";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatDialog } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";

interface CategoryData {
  categoryId?: string;
  Name: string;
  Description?: string;
  isActive?: boolean;
  createdBy?: string;
  createdOn?: string;
  modifiedBy?: string;
  modifiedOn?: string;
}
@Component({
  selector: "app-category",
  templateUrl: "./category.component.html",
  styleUrls: ["./category.component.scss"],
})
export class CategoryComponent implements OnInit {
  [x: string]: any;
  dataSource: any;
  categoryList: any;
  private paginator: MatPaginator;
  // tslint:disable-next-line: variable-name
  public created_By: any;
  displayedColumns: string[] = ["Sno", "name", "Description", "Edit", "delete"];
  public validator = {
    errorMessage: "",
    UniqueCategory: false,
  };
  public shown = {
    grid: true,
    Form: false,
  };
  public categoryEdit = {
    edit: false,
  };

  pageIndex: number;
  pageSize: number;
  length: number;

  Category = new FormGroup({
    categoryId: new FormControl(),
    name: new FormControl(),
    description: new FormControl(),
    isActive: new FormControl(),
    createdBy: new FormControl(),
    createdOn: new FormControl(),
    modifiedBy: new FormControl(),
    modifiedOn: new FormControl(),
  });
  @ViewChild(MatPaginator, { static: false }) set matPaginator(
    mp: MatPaginator
  ) {
    this.paginator = mp;
    //  this.setDataSourceCategory();
  }
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  constructor(
    private router: Router,
    private daoService: DaoService,
    private formBuilder: UntypedFormBuilder,
    private token: LstorageService,
    private spinner: SpinnerService,
    private toast: ToastService,
    public dialog: MatDialog
  ) {
    this.spinner.show();
    this.daoService.getCategory().subscribe(
      (data: any) => {
        this.daoService.defaultCategoryList(data);
        this.daoService.finalCategoryList.subscribe(
          (categoryList) => (this.categoryList = categoryList)
        );
        this.dataSource = new MatTableDataSource(this.categoryList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        console.log("Error :" + error);
      }
    );
  }
  ngOnInit() {
    this.created_By = jwtDecode(this.token.getToken());
    this.Category = this.fb.group({
      categoryId: [""],
      name: ["", [Validators.required]],
      description: [""],
      isActive: ["true"],
      createdBy: [this.created_By.unique_name],
      createdOn: ["2019-10-05T03:47:43.629Z"],
      modifiedBy: [],
      modifiedOn: ["2019-10-10T11:17:51.838Z"],
    });
  }
  setDataSourceCategory() {
    this.setDataSourceCategory();
    this.dataSource.paginator = this.paginator;
  }

  CategoryForm() {
    this.categoryEdit.edit = false;
    this.shown.grid = false;
    this.shown.Form = true;
    this.Category = this.fb.group({
      categoryId: [""],
      name: ["", [Validators.required]],
      description: [""],
      isActive: [true],
      createdBy: [this.daoService.loggedUser.UserUniqueId],
      createdOn: ["2019-10-05T03:47:43.629Z"],
      modifiedBy: [],
      modifiedOn: [this.daoService.loggedUser.UserUniqueId],
    });
  }

  createCategory() {
    this.validator.UniqueCategory = false;
    this.Category.value.name = this.Category.value.name.trim();
    const categoryData: CategoryData = {
      categoryId:
        this.Category.value.categoryId == ""
          ? null
          : this.category.value.categoryId,
      Description: this.Category.value.description,
      Name: this.category.value.name,
      createdOn: this.category.value.createdOn,
      createdBy: this.category.value.name,
      modifiedOn: this.category.value.modifiedOn,
      modifiedBy: this.category.value.modifiedBy,
      isActive: this.category.value.isActive,
    };
    this.daoService.AddCategory(categoryData).subscribe(
      (data: any) => {
        this.toast.openSnackBar("Category added successfully", "close");
        this.backcategoryList();
      },
      (error) => {
        this.validator.UniqueCategory = true;
        this.validator.errorMessage = error.error.userMessage;
      }
    );
  }

  editCategory(id) {
    this.shown.grid = false;
    this.shown.Form = true;
    this.categoryEdit.edit = true;
    this.daoService.getCategoryById(id).subscribe((data: any) => {
      this.Category = this.fb.group({
        categoryId: [id],
        name: [data.name, [Validators.required]],
        description: [data.description],
        modifiedBy: [this.created_By.unique_name],
      });
    });
  }

  /*  deleteCategory(id, index) {
    this.daoService.deleteCategoryById(id).subscribe((data: any) => {
        this.categoryList = this.removeFromArrayOfHash(this.categoryList, 'categoryId', data.data.categoryId);
        this.toast.openSnackBar("Category deleted successfully", 'close');
      // this.apiListofData = this.apiListofData.splice(0, index);
      this.dataSource = new MatTableDataSource(this.categoryList);
      this.dataSource.paginator = this.paginator;
    });

    }*/

  //DeleteCategory
  deleteCategory(id, index) {
    this.daoService.defaultCategoryId(id);
    this.daoService.categoryDelete(true);
    const dialogRef = this.dialog.open(UserdeleteComponent, {
      disableClose: true,
      panelClass: "custom-dialog-container",
      width: "376px",
      height: "145px",
      autoFocus: true,
    });

    dialogRef.beforeClosed().subscribe((data) => {
      this.daoService.categoryDelete(false);
      this.daoService.finalCategoryList.subscribe(
        (categoryList) => (this.categoryList = categoryList)
      );
      this.dataSource = new MatTableDataSource(this.categoryList);
      this.daoService.defaultCategoryId(null);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  removeFromArrayOfHash(p_array_of_hash, p_key, p_value_to_remove) {
    return p_array_of_hash.filter((l_cur_row) => {
      return l_cur_row[p_key] != p_value_to_remove;
    });
  }

  backcategoryList() {
    this.spinner.show();
    this.shown.grid = true;
    this.shown.Form = false;
    this.validator.UniqueCategory = false;
    this.daoService.getCategory().subscribe(
      (data: any) => {
        this.categoryList = data;
        this.spinner.hide();
        this.dataSource = new MatTableDataSource(this.categoryList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      (error) => {
        this.spinner.hide();
        console.log("Error: " + error);
      }
    );
  }

  categoryFilter = (value: string) => {
    this.dataSource.filter = value;
  };

  handleInput(event) {
    if (event.which === 32 && !this.Category.value.name.length)
      event.preventDefault();
  }

  //For store pagination details
  public handlePage(e: any) {
    this.pageIndex = e.pageIndex;
    this.pageSize = e.pageSize;
    this.length = e.length;
  }
}
